import * as z from 'zod';

import { withPasswordRequirements } from '../../../common/validations/password-requirements';

export const signInFormSchema = z.object({
  email: z.string().trim().email(),
  password: withPasswordRequirements(z.string().trim()),
});
